import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class OnlynumberDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event:any) {

    const initalValue:string = this._el.nativeElement.value;

    this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '').replace(/(.{4})/g, '$1 ').trim();
    if ( initalValue !== this._el.nativeElement.value ||  this._el.nativeElement.value.length > 16 ) {
      event.stopPropagation();
    }
  }

}
